import { Injectable } from '@angular/core';
import { HssResponse } from './HssResponse';
import { HssErrorResponse } from './HssErrorResponse';
import { InfoApiService } from './info.api.service';

@Injectable({
  providedIn: 'root'
})
export class InfoDataService {
  degreeCourseData: any[] = [];
  constructor(private _info: InfoApiService) { }

  // View degree courses by degree id
}
